export default class SessionExpiredError extends Error {}
